<template>
  <div>
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <span class="m-0 font-weight-bold text-primary">Order List</span>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th>#</th>
                <th>Date & Time</th>
                <th>Name</th>
                <th>Products</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody v-if="AllOrders.data">
              <tr v-for="(ord, orderindex) in AllOrders.data" :key="orderindex">
                <td>{{ ++orderindex }}</td>
                <td>
                  {{
                    new Date(ord.createdAt * 1000).toLocaleDateString("en-us", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit"
                    })
                  }}
                </td>
                <td>
                  {{
                    ord.name
                      ? ord.name + "  " + ord.number
                      : "" + "  " + ord.number
                  }}
                </td>
                <td>
                  <b-btn
                    v-b-toggle="'order' + orderindex"
                    class="form-control btn btn-warning"
                  >
                    Bucket
                  </b-btn>
                  <b-collapse v-bind:id="'order' + orderindex" class="pt-2">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Qty</th>
                          <th>Price</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(buk, i) in ord.product" :key="i">
                          <td>{{ ++i }}</td>
                          <td>{{ buk.name }}</td>
                          <td>{{ buk.qty + " " + buk.unitType }}</td>
                          <td>{{ buk.price }}</td>
                          <td>
                            <span
                              class="badge badge-danger"
                              v-if="buk.currentStatus.type === '0'"
                              >pending</span
                            >
                            <span
                              class="badge badge-primary"
                              v-if="buk.currentStatus.type === '1'"
                              >Assigned for packing</span
                            >
                            <span
                              class="badge badge-warning"
                              v-if="buk.currentStatus.type === '2'"
                              >Assigned for Delivery</span
                            >
                            <span
                              class="badge badge-default"
                              v-if="buk.currentStatus.type === '3'"
                              >Delivered</span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-collapse>
                </td>
                <td>{{ ord.delveryCharges + ord.orderAmount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const $ = window.$;
import { dbFs } from "@/modules/database";
export default {
  data() {
    return {
      lessorders: [],
      flag: 0,
      pagiperPage: 10,
      pagicurrentPage: 1,
      dataTable: null,
      customers: [],
      products: [],
      buckets: [],
      vendors: [],
      loading: false,
      couponId: this.$route.params.id,
      orders: [],
      fields: [
        {
          key: "sr",
          label: "#",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "date",
          label: "Date & Time",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "customername",
          label: "Customer Name",
          class: "text-center"
        },
        {
          key: "product",
          label: "Products",
          class: "text-center"
        },
        {
          key: "total",
          label: "Total Amount",
          sortable: true,
          class: "text-center"
        },
        {
          key: "vendorname",
          label: "Vendor Name",
          class: "text-center"
        },
        {
          key: "payment",
          label: "Payment Method",
          class: "text-center"
        },
        {
          key: "status",
          label: "Status",
          class: "text-center"
        }
      ],
      items: [],
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      AllOrders: []
    };
  },

  mounted() {
    this.setupFirebaseReading();
  },
  methods: {
    setupFirebaseReading: function() {
      const vendorId = this.couponId;
      const orders = [];
      const customers = [];
      const allProducts = [];
      const vendorProducts = [];
      dbFs
        .collection("products")
        .get()
        .then(prod => {
          prod.forEach(doc => {
            allProducts.push(doc.data());
          });
        })
        .catch(err => {
          console.log(err);
        });

      dbFs
        .collection("order")
        .where("couponId", "==", vendorId)
        // .orderBy("createdAt", "desc")
        .get()
        .then(res => {
          res.forEach(doc => {
            orders.push({ ...doc.data(), orderId: doc.id });
          });
          getCustomers();
        })
        .catch(err => {
          console.log(err);
        });
      const getCustomers = () => {
        orders.forEach((ord, index) => {
          dbFs
            .collection("customer")
            .doc(ord.customerId)
            .get()
            .then(doc => {
              customers.push({
                ...doc.data(),
                uid: doc.id,
                order: ord,
                venderId: vendorId
              });

              if (index === orders.length - 1) {
                getProducts();
              }
            })
            .catch(err => {
              console.log(err);
            });
        });
      };
      const getProducts = () => {
        customers.forEach((ct, indexs) => {
          const ctlength = customers.length - 1;
          ct.order.vendorId.forEach(vd => {
            if (vd === vendorId) {
              dbFs
                .collection("order")
                .doc(ct.order.orderId)
                .collection("vendor")
                .doc(vendorId)
                .get()
                .then(doc => {
                  vendorProducts.push({ ...ct, products: doc.data() });
                  console.log(customers.length - 1, indexs, "checkerror");

                  if (indexs === ctlength) {
                    getProductsName();
                  }
                })
                .catch(err => {
                  console.log(err);
                });
            }
          });
        });
      };
      const getProductsName = () => {
        // console.log("dispatching");
        vendorProducts.forEach((pd, index) => {
          pd.products.product.forEach((prod, i) => {
            const tempProd = allProducts.find(
              ap => ap.productId === prod.productId
            );
            if (tempProd) {
              vendorProducts[index].products.product[i].name = tempProd.name;
            }
          });
        });
      };
      this.AllOrders = vendorProducts;
    },
    getCustomersData() {
      this.loading = true;
      this.$bind("customers", dbFs.collection("customer"))
        .catch(error => {
          this.loading = false;
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCustomer(id, dataType) {
      let personalDetails = {
        name: "Not Available",
        number: "Not found",
        email: ""
      };
      for (const cusKey of Object.keys(this.customers)) {
        const customer = this.customers[cusKey];
        if (id == customer.id) {
          personalDetails = customer;
        }
      }
      if (dataType == "name") {
        return personalDetails.name + " \n " + personalDetails.number;
      }
      if (dataType == "email") {
        return personalDetails.email;
      } else {
        return personalDetails.number;
      }
    },
    getProductsData() {
      this.loading = true;
      this.$bind("products", dbFs.collection("products"))
        .catch(error => {
          console.log(error);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBucketData() {
      this.loading = true;
      this.$bind("buckets", dbFs.collection("bucket"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProduct(id, dataType) {
      let productDetails = {
        name: "Not Found",
        unitType: "",
        image: ""
      };
      for (const cusKey of Object.keys(this.products)) {
        const product = this.products[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getVendorsData() {
      this.loading = true;
      this.$bind("vendors", dbFs.collection("vendor"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getVendor(id, dataType) {
      let VendorDetails = {
        shopDetails: {
          name: "Not Found",
          address: {
            firstLine: "",
            city: "",
            state: "",
            pincode: ""
          }
        },
        personalDetails: {
          name: "Not Found"
        }
      };
      for (const cusKey of Object.keys(this.vendors)) {
        const vendor = this.vendors[cusKey];
        if (id == vendor.id) {
          VendorDetails = vendor;
        }
      }
      if (dataType == "shopname") {
        return VendorDetails.shopDetails.name;
      }
      if (dataType == "ownername") {
        return VendorDetails.personalDetails.name;
      }
      if (dataType == "address") {
        let address = `${VendorDetails.shopDetails.address.firstLine},
        ${VendorDetails.shopDetails.address.city},
        ${VendorDetails.shopDetails.address.state},
        ${VendorDetails.shopDetails.address.pincode}`;
        return address;
      }
    },
    getBucket(id, dataType) {
      let bucketData = {};
      for (const cusKey of Object.keys(this.buckets)) {
        const bucket = this.buckets[cusKey];
        if (id == bucket.id) {
          bucketData = bucket;
        }
      }
      if (dataType == "all") {
        return bucketData;
      }
      if (dataType == "total") {
        let total = 0;
        if (bucketData.product) {
          for (const buck of bucketData.product) {
            let amount = buck.price;
            total += amount;
          }
        }
        return total + 50;
      }
    },
    getLastOrderStatus(status) {
      let lastarr = status.slice(-1)[0];
      return [lastarr];
    },
    forDataTable() {
      this.dataTable = $("#dataTable").DataTable({
        lengthMenu: [10, 20]
      });
    }
  }
};
</script>

<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
